// document.write("<script type='text/javascript' src='src/assets/js/base64.js'></script>");
// var server_url_https = 'https://sa.aunload.com:4006/sa?project=default';
var server_url_https = 'https://sa.aunload.com:4006/sa?project=production';
function generateUrl(server_url, page_url, props) {
    var app_store_url = 'redirect_url=' + encodeURIComponent(page_url);
    //  匹配以sa结尾的或者sa?xx结尾的
    var url = server_url.replace(/\/sa$/, '/track_installation').replace(/(\/sa)(\?[^\/]+)$/, '/track_installation$2');
    console.log(url);
    if (url.indexOf('?') === -1) {
        url = url + '?' + app_store_url + getIoschPara(props);
    } else {
        url = url + '&' + app_store_url + getIoschPara(props);
    }
    return url;
}

function getIoschPara(props) {
    var iosData = JSON.stringify({
        distinct_id: 'ios_channel_track_id',
        event: 'ios_channel_track_event',
        properties: props,
        type: 'track_installation'
    });
    return '&data=' + encodeURIComponent(Base64.encode(iosData));
}
const mixin = {
    methods: {
        validToken(path,entryButton) {
            let access_token = localStorage.access_token;
            let expire_time = localStorage.expire_time;
            let now = new Date().getTime()
            if (!access_token || (access_token && expire_time <= now)) {
                if (path) {
                    this.$router.push({ name: "login", query: { path: path, entryButton: entryButton } });
                } else {
                    this.$router.push({ name: "login" });
                }
            } else {
                return true
            }
        },
        refreshToken(resolve) {
            let access_token = localStorage.access_token;
            let refresh_token = localStorage.refresh_token;
            let path = ""
            if (!refresh_token) {
                if (path) {
                    this.$router.push({ name: "login", query: { path: path } });
                } else {
                    this.$router.push({ name: "login" });
                }
            } else {
                let data = {
                    'access_token': access_token,
                    'refresh_token': refresh_token
                }
                let result = true;
                var vm = this;

                vm.$store.dispatch("refresh", data).then((res => {
                    var res = res.data;
                    if (res.code == 0) {
                        let token = res.res;
                        localStorage.access_token = token.access_token;
                        localStorage.expire_time = token.expire_time;
                        localStorage.refresh_expire_time = token.refresh_expire_time;
                        localStorage.refresh_token = token.refresh_token;
                        result = true
                        resolve(token.access_token);
                    } else {
                        if (path) {
                            vm.$router.push({ name: "login", query: { path: path } });
                        } else {
                            vm.$router.push({ name: "login" });
                        }
                    }
                }))


            }
        },
        isWeiXin(){
            var ua = window.navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                return true;
            }else{
                return false;
            }
        },
        isAlipay(){
            var ua = window.navigator.userAgent.toLowerCase();
            if(ua.match(/Alipay/i) == "alipay"){
                return true;
            }else{
                return false;
            }
        },
        sa_download_gsx_app(event, download_channel, download_channel_name) {
            var pre_prop = sa.getPresetProperties();
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    var props = {
                        $sd_import_keys: 'url_path,search_keyword',
                        $utm_source: pre_prop.$latest_utm_source,
                        $utm_medium: pre_prop.$latest_utm_medium,
                        $utm_term: pre_prop.$latest_utm_term,
                        $utm_content: pre_prop.$latest_utm_content,
                        $utm_campaign: pre_prop.$latest_utm_campaign,
                        search_keyword: pre_prop.$latest_search_keyword,
                        url_path: document.domain + location.pathname
                    };
                    var sa_url = generateUrl(server_url_https, me.href, props);
                    location.href = sa_url; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('wDownloadApplication', {
                download_referer_url: window.location.href,
                download_product: '果师兄恢复大师App',
                download_channel: download_channel,
                download_channel_name: download_channel_name,
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_good_selected(goodsName,goodsCategory,url) {
            if (!sa) {
                return
            }
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mGoodSelected', {
                goodsName:goodsName,
                goodsCategory:goodsCategory,
                $url:url
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_submit_order(orderAmount,kxuid,goodsName,goodsCategory,packageName,url,propertyList) {
            if (!sa) {
                return
            }
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mSubmitOrder', {
                orderAmount:orderAmount,
                kxuid:kxuid,
                goodsName:goodsName,
                goodsCategory:goodsCategory,
                packageName:packageName,
                $url:url,
                propertyList:propertyList
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_login(kxuid,loginType,entrybutton) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mLogin', {
                kxuid:kxuid,
                loginType:loginType,
                entrybutton:entrybutton
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_click_pay(
            orderNo,
            orderAmount,
            kxuid,
            packageName,
            goodsName,
            commodityAmount,
            serviceFees,
            couponAmount,
            installments
            ) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mClickPay', {
                orderNo:orderNo,
                orderAmount:orderAmount,
                kxuid:kxuid,
                packageName:packageName,
                goodsName:goodsName,
                commodityAmount:commodityAmount,
                serviceFees:serviceFees,
                couponAmount:couponAmount,
                installments:installments
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_pay_result(
            orderNo,
            orderAmount,
            kxuid,
            packageName,
            goodsCategory,
            goodsName,
            payType,
            payStatus,
            installments
            ) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mPayResult', {
                orderNo:orderNo,
                orderAmount:orderAmount,
                kxuid:kxuid,
                packageName:packageName,
                goodsCategory:goodsCategory,
                goodsName:goodsName,
                payType:payType,
                payStatus:payStatus,
                installments
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_click_all_service(ServiceCategory) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mClickAllService', {
                ServiceCategory
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_package_selected(packageName,isDefault,goodsName) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mPackageSelected', {
                packageName,
                isDefault,
                goodsName
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_purchase_goods(goodsName,url) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mPurchaseGoods', {
                goodsName,
                $url: url
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_click_promise_detail (url) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mClickPromiseDetail', {
                $url: url
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_qualification (url,qualityName) {
            if (!sa) {
                return
            }
            // event.preventDefault(); // 阻止默认跳转
            // var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mQualification', {
                $url: url,
                qualityName
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_business_licence (url) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mBusinessLicence', {
                $url: url
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_scene_element (goodsName,SceneCategory) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mSceneElement', {
                goodsName,
                SceneCategory
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_hot_question (goodsName,question) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mHotQuestion', {
                goodsName,
                question
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_click_FAQ (goodsName) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mClickFAQ', {
                goodsName
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_recommend_goods (reGoodsName,goodsName) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mRecommendGoods', {
                reGoodsName,
                goodsName
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_consult_button () {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mConsultButton', {
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_click_sort () {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mClickSort', {
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_sort (sortCategory) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mSort', {
                sortCategory
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_check_engineer_detail (OnlineStatus,engineerName,engineerId) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mCheckEngineerDetail', {
                OnlineStatus,
                engineerName,
                engineerId
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_select_service (goodsName,engineerName,engineerId) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mSelectService', {
                goodsName,
                engineerName,
                engineerId
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_m_invoice () {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mInvoice', {
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_g_service_advantage (contentItem) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mServiceAdvantage', {
                contentItem
            }, track_a_click); //把跳转操作加在callback里
        },
        sa_g_aggregation (articleUrl,aggregationCategory) {
            if (!sa) {
                return
            }
            event.preventDefault(); // 阻止默认跳转
            var me = event.currentTarget;
            var hasCalled = false;
            setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
            function track_a_click() {
                if (!hasCalled) {
                    hasCalled = true;
                    // location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
                }
            }
            sa.track('mAggregation', {
                articleUrl,
                aggregationCategory
            }, track_a_click); //把跳转操作加在callback里
        },
        set_distinct_id() {
            let distinct_id = Date.now().toString(36)
            distinct_id += Math.random().toString(36).substr(3,36)
            sa.identify(distinct_id, true)
        },
      //发起咨询
      set_m_by_consult() {
        if (!sa) {
          return
        }
        event.preventDefault(); // 阻止默认跳转
        var me = event.currentTarget;
        var hasCalled = false;
        setTimeout(track_a_click, 400); //如果没有回调成功，设置超时回调
        function track_a_click() {
          if (!hasCalled) {
            hasCalled = true;
            location.href = me.href; //把 A 链接的点击跳转,改成 location 的方式跳转
          }
        }
        sa.track('mByConsult', {
        }, track_a_click);
      }
    }
}
export default mixin



// WEBPACK FOOTER //
// ./src/assets/js/mixins.js